import { IProduct, IProductStatus, IContact } from "@nkr/models/index";

export enum ProductSection {
    TargetedProducts = 1,
    PotentialTargetedProducts = 2,
    NonTargeted = 3
}

export interface ILookupData {
    products: IProduct[],
    staff: IContact[],
    statuses: IProductStatus[]
}

export { ICrmState } from './state';

export {
    ActionCreators, ICrmLookupDataResponse, ICrmAccountPlanResponse,
    ISaveProductCenterResponse,
    IProductListResponse, ISaveProductResponse,
    IProductCenterListResponse,
    IProductCenterResponse,
    IProductCenterForListResponse
} from './actions'

export { Reducer } from './reducers';

export { userContactMap, CenterOptionsOrigin } from './user-contact-map';